import { mapState } from 'pinia';
import { useSurveyStore } from '@/store';
import { BACKGROUND_WHITE } from '@/enum/Background';
import { FeedbackType } from '@/enum/FeedbackType';
import { FEEDBACK_TYPE_FULL, FEEDBACK_TYPE_NONE } from '../../enum/FeedbackType';

export default {
  data() {
    return {
      loading: true,

      considerationLevel: null,
      highRiskIndicator: false,
      bddIndicator: false,
      impulsivityIndicator: false,
      referralForm: false,
      advices: [],
      reportQuestionAnswers: {},

      receivedResult: false,

      showDebugInfo: false,

      reportSubmissionToken: null,
      reportCliniqueVerificationToken: null,

      surveyName: null,

      FeedbackTypeEnum: FeedbackType,
    };
  },
  computed: {
    ...mapState(useSurveyStore, ['submissionToken', 'cliniqueVerificationToken', 'questionAnswers', 'surveyResult', 'questionGroups', 'treatmentCategories', 'diagnosisCategories', 'consent', 'isAnonymous', 'feedbackType']),
    justShowGivenAnswers() {
      return this.surveyIdentifier !== 'main';
    },
    hasReceivedResultAlready() {
      return this.questionAnswers && this.surveyResult;
    },
    surveyIdentifier() {
      return this.$router.currentRoute?.value?.params?.surveyIdentifier;
    },
    FEEDBACK_TYPE_NONE() {
      return FEEDBACK_TYPE_NONE;
    },
    FEEDBACK_TYPE_FULL() {
      return FEEDBACK_TYPE_FULL;
    },
    showReport() {
      return this.feedbackType === this.FEEDBACK_TYPE_FULL;
    },
  },
  mounted() {
    useSurveyStore().setBackground(BACKGROUND_WHITE);

    this.loading = true;

    // Fetch submission token from url, path or store
    const submissionToken = this.$router?.currentRoute?.value?.query?.token
      || this.$router?.currentRoute?.value?.params?.token;

    if (this.submissionToken) {
      this.reportSubmissionToken = this.submissionToken;
    } else if (submissionToken) {
      this.reportSubmissionToken = submissionToken;
    } else {
      this.reportSubmissionToken = null;
    }

    // Fetch clinique verification token from url, path or store
    const cliniqueVerificationToken = this.$router?.currentRoute?.value?.query?.cliniqueVerificationToken
      || this.$router?.currentRoute?.value?.params?.cliniqueVerificationToken;

    if (this.cliniqueVerificationToken) {
      this.reportCliniqueVerificationToken = this.cliniqueVerificationToken;
    } else if (cliniqueVerificationToken) {
      this.reportCliniqueVerificationToken = cliniqueVerificationToken;
    } else {
      this.reportCliniqueVerificationToken = null;
    }

    this.$apiClient.setDefaultHeader('X-Clinique-Token-Verification', this.reportCliniqueVerificationToken);

    /* console.log({
      submissionToken,
      reportCliniqueVerificationToken: this.reportCliniqueVerificationToken,
      router: this.$router,
    }); */

    if (!this.reportSubmissionToken && !this.hasReceivedResultAlready) {
      console.log('No submission token in the store nor the URL (and no existing result was found)');

      this.$router.push('/');

      return;
    }

    const hasAllValues = this.hasValues(this.questionGroups)
      && this.hasValues(this.treatmentCategories)
      && this.hasValues(this.diagnosisCategories)
      && this.hasValues(this.questionAnswers)
      && this.hasValues(this.surveyResult);

    if (hasAllValues) {
      this.onUserData();
      this.onGameDataReceived();
    } else {
      this.$apiClient.misc.getGameData()
        .then((gameData) => {
          useSurveyStore().setTreatmentCategories(gameData.treatmentCategories);
          useSurveyStore().setDiagnosisCategories(gameData.diagnosisCategories);

          return this.$apiClient.survey.getSurvey(this.surveyIdentifier);
        })
        .then((surveyData) => {
          this.surveyName = surveyData.name;

          useSurveyStore().setQuestionGroups(surveyData.questionGroups);

          return this.$apiClient.survey.getUserAnswers(this.surveyIdentifier, this.reportSubmissionToken);
        })
        .then((userAnswersData) => {
          useSurveyStore().setQuestionAnswers(userAnswersData.answers);
          useSurveyStore().setSurveyResult(userAnswersData.result);
          useSurveyStore().setConsent(userAnswersData.consent);
          useSurveyStore().setIsAnonymous(userAnswersData.anonymous);
          useSurveyStore().setFeedbackType(userAnswersData.feedbackType);

          console.log('userAnswersData', userAnswersData);

          this.onUserData();

          // console.log('questionGroups', this.questionGroups);
          // console.log('treatmentCategories', this.treatmentCategories);
          // console.log('diagnosisCategories', this.diagnosisCategories);
          // console.log('questionAnswers', this.questionAnswers);
          // console.log('surveyResult', this.surveyResult);
          this.onGameDataReceived();
        });
    }
  },
  methods: {
    onUserData() {
      // Override
    },
    hasValues(value) {
      if (value instanceof Array) {
        return value.length > 0;
      }

      if (typeof value === 'object' && value) {
        return Object.keys(value).length > 0;
      }

      return !!value;
    },
    loadGameData() {
      if (this.questionGroups && this.treatmentCategories && this.diagnosisCategories && this.questionAnswers && this.surveyResult) {
        this.onGameDataReceived();
      } else {
        this.$apiClient.misc.getGameData()
          .then((gameData) => {
            useSurveyStore().setTreatmentCategories(gameData.treatmentCategories);
            useSurveyStore().setDiagnosisCategories(gameData.diagnosisCategories);

            return this.$apiClient.survey.getSurvey(this.surveyIdentifier);
          })
          .then((surveyData) => {
            useSurveyStore().setQuestionGroups(surveyData.questionGroups);

            return this.$apiClient.survey.getUserAnswers(this.surveyIdentifier, this.reportSubmissionToken);
          })
          .then((userAnswersData) => {
            useSurveyStore().setQuestionAnswers(userAnswersData.answers);
            useSurveyStore().setSurveyResult(userAnswersData.result);

            this.onGameDataReceived();
          });
      }
    },

    onGameDataReceived() {
      console.log('this.questionAnswers', this.questionAnswers);
      console.log('this.surveyResult', this.surveyResult);

      if (this.hasReceivedResultAlready) {
        this.onUserAnswersAndResult(this.questionAnswers, this.surveyResult);

        this.loading = false;
      } else if (this.reportSubmissionToken !== 'anonymous') {
        // Fetch current answers
        this.$apiClient.survey.getUserAnswers(this.surveyIdentifier, this.reportSubmissionToken).then((data) => {
          this.onUserAnswersAndResult(data.answers, data.result);

          this.loading = false;
        }).catch((e) => {
          this.$router.push('/');
        });
      } else {
        // Anonymous and no answers given
        throw new Error('Could not find user answers since submission token was empty and so was the questions/results');
      }
    },

    onUserAnswersAndResult(answers, result) {
      this.reportQuestionAnswers = answers;

      this.receivedResult = !!result;

      if (this.receivedResult) {
        this.advices = result.advice;
        this.considerationLevel = result.considerationLevel;
        this.highRiskIndicator = result.indicatorsActive.highRisk;
        this.bddIndicator = result.indicatorsActive.bdd;
        this.impulsivityIndicator = result.indicatorsActive.impulsivity;
        this.referralForm = result.indicatorsActive.referralForm;
      } else {
        this.advices = [];
        this.considerationLevel = null;
        this.highRiskIndicator = null;
        this.bddIndicator = null;
        this.impulsivityIndicator = null;
        this.referralForm = null;
      }
    },
  },
};
